


// import React, { useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./HomePageBannerFeature.css";
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import icon1 from '../../assets/harvest.json'

// const features = [
//   {
//     title: "Product Listing",
//     description: "Farmer lists produce include image upload, quantity, expected price, location ",
//     icon:icon1
//   },
//   {
//     title: "Buyer Engagement",
//     description: "Verified buyers view and make offers",
//   },
//   {
//     title: "Order Processing", 
//     description: "Orders confirmed; logistics coordinated optional ShambaSync delivery support",
//   },
//   {
//     title: "Secure Transactions",
//     description: "Farmer receives payment securely",
//   },
// ];

// const HomePageBannerFeature = () => {
//   useEffect(() => {
//     AOS.init({ duration: 1000, once: true });
//   }, []);

//   return (
//     <div className="container-fluid feature-container">
//       <div className="row feature-row">
//         {features.map((feature, index) => (
//           <div
//             key={index}
//             className="col-12 col-sm-6 col-lg-3 feature-col"
//             data-aos="fade-up"
//             data-aos-delay={index * 150}
//           >
//             <div className="feature-card">
//               <div className="feature-number">{index + 1}</div>
              
//               <h3 className="feature-title">{feature.title}</h3>
//               <p className="feature-description">{feature.description}</p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default HomePageBannerFeature;


import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HomePageBannerFeature.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Player } from "@lottiefiles/react-lottie-player";

// Import your Lottie icons
import icon1 from '../../assets/harvest.json';
import icon2 from '../../assets/Customer Experience.json';
import icon3 from '../../assets/Grocery.json';
import icon4 from '../../assets/Safe and secure.json';

const features = [
  {
    title: "Product Listing",
    description: "Sellers list products with images, descriptions, pricing, and stock availability",
    icon: icon1
  },
  {
    title: "Customer Shopping",
    description: "Customers browse, compare, and add items to cart",
    icon: icon2
  },
  {
    title: "Order Processing",
    description: "Orders confirmed; shipping coordinated with reliable delivery partners",
    icon: icon3
  },
  {
    title: "Secure Transactions",
    description: "Sellers receive payment securely through our platform",
    icon: icon4
  },
];

const HomePageBannerFeature = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="container-fluid feature-container">
      <div className="row feature-row">
        {features.map((feature, index) => (
          <div
            key={index}
            className="col-12 col-sm-6 col-lg-3 feature-col"
            data-aos="fade-up"
            data-aos-delay={index * 150}
          >
            <div className="feature-card">
              <div className="d-flex justify-content-between gap-2 ">
                <div className="feature-number mt-4">{index + 1}</div>
                <Player
                  autoplay
                  loop
                  src={feature.icon}
                  style={{ height: "80px", width: "100px" }}
                />
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomePageBannerFeature;
